import { FC, memo } from 'react';
import styled from 'styled-components';
import Hero from '../../Hero/Hero';
import Advantages from '../../Advantages/Advantages';
import About from '../../About/About';
import Gratitude from '../../Gratitude/Gratitude';
import Tarifs from '../../Tarifs/Tarifs';
import Discounts from '../../Discounts/Discounts';
import Partners from '../../Partners/Partners';
import Cooperation from '../../Cooperation/Cooperation';

const MainPage: FC = () => {
    return (
        <StyledMainPage>
            <Hero />
            <Tarifs />
            <Advantages />
            <About />
            <Discounts />
            <Partners />
            <Cooperation />
            <Gratitude />
        </StyledMainPage>
    );
};

const StyledMainPage = memo(styled.div``);

export default memo(MainPage);

